// src/components/Hero.js
import React from 'react';

const Hero = ({ language }) => {
  return (
    <section id="home" className="pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-br from-green-900 via-green-800 to-green-700 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-6 mt-5">
            {/* <span className="inline-block bg-green-600 text-green-100 px-4 py-1 rounded-full text-sm font-medium mb-4">
              {language === 'ar' ? 'التميز في التدريب' : 'Excellence in Training'}
            </span> */}
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              {language === 'ar' ? (
                <>
                  أكاديمية <span className="text-green-300">آرما</span>
                  {/* <br />
                  للتدريب والتطوير */}
                </>
              ) : (
                <>
                  Arma <span className="text-green-300">Academy</span>
                  <br />
                  For Training & Development
                </>
              )}
            </h1>
            <p className="text-xl md:text-2xl text-green-200 mb-8 max-w-2xl mx-auto leading-relaxed">
              {language === 'ar' 
                ? 'التفكير والابداع طريقنا للتميز'
                : 'Thinking and creativity are our path to excellence'}
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button className="bg-white text-green-800 px-8 py-3 rounded-lg font-semibold hover:bg-green-100 transition-all transform hover:-translate-y-1 shadow-lg">
              {language === 'ar' ? 'برامجنا' : 'Our Programs'}
            </button>
            <button className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-green-800 transition-all transform hover:-translate-y-1">
              {language === 'ar' ? 'تواصل معنا' : 'Contact Us'}
            </button>
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {[
            { number: '35+', label: { en: 'Years Experience', ar: 'سنوات من الخبرة' } },
            { number: '500+', label: { en: 'Training Programs', ar: 'برنامج تدريبي' } },
            { number: '10K+', label: { en: 'Graduates', ar: 'خريج' } },
            { number: '50+', label: { en: 'Expert Trainers', ar: 'مدرب خبير' } },
          ].map((stat, index) => (
            <div 
              key={index}
              className="bg-green-800 bg-opacity-50 backdrop-blur-sm p-6 rounded-xl text-center border border-green-700 transform hover:scale-105 transition-all duration-300"
            >
              <div className="text-3xl font-bold text-green-300 mb-2">{stat.number}</div>
              <div className="text-green-200 text-sm">{language === 'ar' ? stat.label.ar : stat.label.en}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;